import { Component } from '@angular/core';
@Component({
  selector: 'app-copoun',
  templateUrl: './copoun.component.html',
  styleUrls: ['./copoun.component.scss']
})
export class CopounComponent {
}
